module.exports = __webpack_public_path__ + "img/bg1.cc89f4f7.png";